import { useIntl } from 'react-intl'
import styled from 'styled-components'
import Pill from 'LuxKit/Pill'
import SolidSparklesIcon from 'LuxKit/Icons/solid/SolidSparklesIcon'

const PickedForYouPill = styled(Pill)`
  align-self: flex-start;
`

function CartPanelPickedForYouPill() {
  const intl = useIntl()

  return (
    <PickedForYouPill startIcon={<SolidSparklesIcon />}>
      {intl.formatMessage({
        id: 'KUUE4XT7BqIq4IZ5Hmc0',
        defaultMessage: 'Picked for you',
        description: 'Label indicating the room was auto-selected by the system in the cart panel',
      })}
    </PickedForYouPill>
  )
}

export default CartPanelPickedForYouPill
